import { Link } from "react-router-dom";

import styled from "@emotion/styled";

export const WrapperOne = styled.div`
  justify-content: space-between;
  align-items: center;
  display: flex;
  align-items: stretch;

  margin-bottom: ${p => p.theme.space[5]}px;
  padding: 0 ${p => p.theme.space[6]}px;

  @media (min-width: ${({ theme }) => theme.screenSizes.mdMax}) {
    flex-direction: column;
    gap: 10px;
    margin-bottom: 20px;
  }

  @media (min-width: 1190px) {
    flex-direction: row;
  }
`;

export const WrapperTwo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

export const StyledLink = styled(Link)`
  padding: 4px 12px;
  background-color: ${p => p.theme.colors.accent.green};
  border-radius: ${p => p.theme.radii.medium};
  font-size: 16px;
  color: ${p => p.theme.colors.black};
  text-decoration: none;
  line-height: normal;
  transition: all 0.3s ease-in-out;

  -webkit-tap-highlight-color: transparent;

  display: flex;
  align-items: center;
  text-align: center;
  justify-content: center;

  :hover {
    background-color: ${p => p.theme.colors.hover.background};
    border-color: ${p => p.theme.colors.hover.border};
  }

  :active {
    background-color: ${p => p.theme.colors.active.background};
    border-color: ${p => p.theme.colors.active.border};
  }

  @media screen and (min-width: ${p => p.theme.screenSizes.mdMax}) {
    padding: 8px 14px;
    border-radius: 8px;
    font-size: ${p => p.theme.fontSizes.m};
    line-height: 1.33;
  }
`;

export const OtherArticleList = styled.ul`
  display: flex;
  flex-direction: column;

  gap: ${p => p.theme.space[5]}px;
    
    @media screen and (min-width: ${p => p.theme.screenSizes.mdMax}) {
        gap: 20px;
    }}
`;
